import * as Yup from "yup";
import { addMethod, setLocale } from "yup";

const initYup = () => {
    addMethod(Yup.date, 'endDate', function () {
        return this.test(function (value, context) {
            if (value! < context.parent.startDate) {
                return this.createError({ message: `Data końcowa nie może być starsza niż początkowa` });
            }
            return true;
        })
    });

    setLocale({
        mixed: {
            default: 'Pole zawiera błędy',
            required: 'Wymagane',
            notType: function notType(_ref) {
                switch (_ref.type) {
                    case 'date':
                        return 'Nieprawidłowa data';
                    default:
                        return 'Nieprawidłowy format';
                }
            }
        },
        number: {
            min: ({ min }) => {
                return 'Dozwolona minimalna wartość ' + min
            },
            max: ({ max }) => {
                return 'Dozwolona maksymalna wartość ' + max
            },
        },
        string: {
            email: 'Wartość musi być poprawnym adresem e-mail',
            matches: ({ regex }) => 'Wartość musi pasować do wzorca: ' + regex,
        },
        array: {
            min: ({ min }) => `Wymagana minimalna liczba wybranych opcji: ${ min }`,
            max: ({ max }) => `Maksymalna dozwolona liczba wybranych opcji: ${ max }`,
        }
    })
}
export default initYup;